import {useQuery} from '@apollo/client';
import { GET_MANUFACTURERS } from '../../Queries/manufacturers';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';

const UseGetAllManufacturers = (lang) => {

    const [variables,SetVariables] = useState({
        searchText:"",
        lang,
        limit:40,
        offset:0
    });

    const client = useApolloClient();
    const {t} = useTranslation();
    const [content,SetContent] = useState(null);
    const [selectedManufacturerIDs,SetSelectedManufacturerIDs] = useState([]);

    const {data,loading,error,fetchMore,refetch} = useQuery(GET_MANUFACTURERS,{
        variables:variables,
        fetchPolicy:"network-only",
        skip:(variables.lang == "" ? true : false)
    })

    const FetchMore = (offset) => {

        fetchMore({
            variables: {
                offset: offset
            },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                return Object.assign({}, prev, {
                    AllManufacturers: [...prev.AllManufacturers, ...fetchMoreResult.AllManufacturers]
                });
            }
        });
    }

    const GoToPage = (page) => {

        SetVariables((prevValue) => {

            var newOffset = (page - 1) * prevValue.limit;
            if(newOffset == prevValue.offset)
                refetch();

            return {...prevValue,offset:newOffset}

        })
    }

    useEffect(() => {

        if(lang)
            SetVariables({...variables,lang:lang})

    },[lang])

    useEffect(() => {

        if(data)
        {
            const contentData = GetContentData(data.AllManufacturers);
            SetContent(contentData);
        }

    },[data])

    var headerData = [
        {
            value: t("ManufacturerName"),
            className:"flex-1"
        },
        {
            value: t("Shortcut"),
            className:"static text-center"
        }
    ];

    const GetContentData = (data) => {

        var contentData = [];

        for(let val of data)
        {
            var cData = {
                data:[
                    {
                        value:val.name,
                        className:"flex-1"
                    },
                    {
                        value: val.shortcut,
                        className:"static text-center"
                    }
                ],
            }

            cData.rowID    = val.manufacturerID;
            cData.selected = false;

            contentData.push(cData)
        }
        return contentData;
    }

    const SelectRow = (e,manufacturerID) => {

        var checked = e.target.checked;
        var newSelectedManufacturerIDs = [...selectedManufacturerIDs];
        const newList = SelectManufacturerID(content,manufacturerID,checked,newSelectedManufacturerIDs)

        SetContent(newList);
        SetSelectedManufacturerIDs(newSelectedManufacturerIDs);
    }

    const SelectAll = (e) => {

        var checked = e.target.checked;
        var newSelectedManufacturerIDs = [];
        const newList = SelectManufacturerID(content,"all",checked,newSelectedManufacturerIDs)

        SetSelectedManufacturerIDs(newSelectedManufacturerIDs);
        SetContent(newList);
    }

    const SelectManufacturerID = (list,manufacturerID,checked,selectedManufacturerIDs) => {

        const newList = [...list];
        for(let i = 0; i < newList.length; i++)
        {
            if(manufacturerID == newList[i].rowID || manufacturerID === "all")
            {
                newList[i] = {...newList[i],selected:checked}
                if(checked)
                    selectedManufacturerIDs.push(newList[i].rowID);
                else
                {
                    for(let j = 0; j < selectedManufacturerIDs.length; j++)
                    {
                        if(selectedManufacturerIDs[j] == newList[i].rowID)
                            selectedManufacturerIDs.splice(j,1);  
                    } 
                }
            }

            if(newList[i].subData)
                newList[i] = {...newList[i],subData:SelectManufacturerID(newList[i].subData,manufacturerID,checked,selectedManufacturerIDs)}
        }

        return newList;
    }

    const UpdateListAfterAddEdit = (selectedManufacturerID,data) => {
        
        const { AllManufacturers, AllManufacturersCount } = client.readQuery({ query: GET_MANUFACTURERS, variables });
        var newArray = [...AllManufacturers];
        var newAllManufacturersCount = AllManufacturersCount;

        if(selectedManufacturerID && selectedManufacturerID != 0)
        {
            for(let i in newArray)
            {
                if(newArray[i].manufacturerID == data.manufacturerID)
                {
                    newArray[i] = {...newArray[i],
                        name: data.name, 
                        shortcut: data.shortcut
                    };
                }
            } 
        }
        else
        {
            newAllManufacturersCount++
            newArray.unshift({
                manufacturerID: data.manufacturerID,
                name: data.name,
                shortcut: data.shortcut
            })
        }
        
        client.writeQuery({ 
            query:GET_MANUFACTURERS,
            variables,
            data:{
                AllManufacturers: newArray,
                AllManufacturersCount: newAllManufacturersCount
            } 
        });
    }

    const UpdateListAfterDelete = (IDs) => {

        var response = IDs.split(",");
        
        const { AllManufacturers,AllManufacturersCount } = client.readQuery({ query: GET_MANUFACTURERS, variables });
        
        var newArray = [...AllManufacturers];
        var newAllManufacturersCount = AllManufacturersCount;
        
        for(let id of response)
        {
            for(let i in newArray)
            {
                if(newArray[i].manufacturerID == id)
                {
                    newArray.splice(i,1);
                    newAllManufacturersCount--
                }
            } 
        } 
        
        client.writeQuery({ 
            query:GET_MANUFACTURERS,
            variables,
            data:{
                AllManufacturers: newArray,
                AllManufacturersCount: newAllManufacturersCount
            } 
        });
    }

    const Filter = (filterData) => {

        var newVariables = {...variables};
        var updated = false;
       
        if(filterData.searchText != "" || (filterData.searchText == "" && newVariables.searchText != ""))
        {
            newVariables.searchText = filterData.searchText;
            updated = true;
        }

        if(updated)
            SetVariables(newVariables)

    }

    return{
        content,
        totalContentLength: data && data.AllManufacturersCount || 0,
        paggingOffset: variables.offset,
        paggingLimit: variables.limit,
        headerData,
        loading,
        error,
        selectedManufacturerIDs,
        GoToPage,
        FetchMore,
        SelectRow,
        SelectAll,
        UpdateListAfterAddEdit,
        UpdateListAfterDelete,
        Filter
    }

}

export default UseGetAllManufacturers;